module.exports = __webpack_public_path__ + "img/room-2.10687ce4.jpg";